export default __webpack_public_path__ + "images/DS.e6de3be.png";